const pagesSettingsPersonsEn = {
  account: {
    dataTableCard: {
      allActionsColumn: {
        changeAccountType: 'Change account type',
        deactivateSuccessfulMessage: 'Deactivated successfully',
        deactivateUser: 'Deactivate user',
        openMenu: 'Open menu',
        resetPassword: 'Reset password'
      },
      invitingActionsColumn: {
        copiedInvitationLink: 'Copied invitation link',
        copyInvitationLink: 'Copy invitation link',
        deleteInvitation: 'Delete invitation',
        deletedInvitation: 'Deleted invitation',
        openMenu: 'Open menu',
        resendInvitation: 'Resend invitation',
        resendInvitationDialog: {
          cancel: 'Cancel',
          email: 'Email',
          resend: 'Resend',
          resendInvitationSuccessfulMessage: 'Invitation resent successfully',
          targetEmailOptionPersonal: '{{email}} (Personal)',
          targetEmailOptionWork: '{{email}} (Work)',
          targetEmailsRequired: 'Select at least one destination.',
          title: 'Resend invitation'
        }
      },
      isExpiredColumn: {
        expired: 'Expired',
        notExpired: 'Not Expired'
      },
      mfaStatusColumn: {
        enabled: 'Enabled',
        notEnabled: 'Not Enabled'
      },
      personTypeColumn: {
        BOARD_MEMBER: 'Board',
        COLLABORATOR: 'Collaborator',
        CONTRACTOR: 'Contractor',
        EMPLOYEE: 'Employee'
      },
      statusColumn: {
        ACTIVE: 'Active',
        DEACTIVATED: 'Deactivated',
        INVITED: 'Invited'
      }
    },
    filterBarButtons: {
      filterChip: {
        status: 'Status',
        statusPlaceholder: 'Search for status'
      },
      freeText: 'Filter name...',
      ssoStatus: {
        all: 'SSO: All',
        linked: 'SSO linked',
        placeholder: 'SSO link status',
        unlinked: 'SSO not linked'
      }
    },
    tabFilterBar: {
      actionButtonMenu: {
        invite: 'Invite',
        inviteGroups: 'Invite groups',
        inviteIndividual: 'Invite individual account',
        inviteIndividually: 'Invite individually',
        inviteOperator: 'Invite staff account'
      },
      addPersonToSendInvitationDialog: {
        addPerson: 'Add person',
        boardMember: 'Board Member',
        boardMemberMasterId: 'Board Member Type',
        // TODO: common.workerType に統一したい
        cancel: 'Cancel',
        collaborator: 'Collaborator',
        collaboratorMasterId: 'Collaborator Type',
        contractFrom: 'Contract from',
        contractor: 'Contractor',
        contractorMasterId: 'Contractor Type',
        email: 'Email',
        employee: 'Employee',
        employeeMasterId: 'Employment Type',
        firstOrGivenName: 'First or given name',
        lastNameOrFamilyName: 'Last name or family name',
        middleName: 'Middle name',
        optionalLabel: '(Optional)',
        title: 'Add person to send invitation',
        validationErrors: {
          contractFrom: 'contract from is required',
          email: 'valid email is required',
          familyName: 'family name is required',
          givenName: 'given name is required',
          submission: 'Registration failed. Please try again.',
          workerType: 'Worker type is required',
          workerTypeMasterId: '{{workerTypeMasterId}} is required'
        },
        workerType: 'Worker type',
        workerTypeMasterId: 'Worker type master'
      },
      inviteIndividuallyDialog: {
        cancel: 'Cancel',
        infoMessage: 'The invitation expires in 2 weeks.',
        invite: 'Invite',
        inviteAs: 'Invite as',
        inviteAsTooltip: `In Dress Code, there are two account types: operator and individual.

The operator account is intended mainly for individuals responsible for back-office operations. It can perform operations allowed by assigned roles, granting specific permissions as required.

The individual account is designated for employees and contractors. It allows them to submit applications to their organization and carry out operations relevant to their worker type.

In most cases, users with an operator account also have a individual account.`,
        inviteCombobox: {
          addPersonToSendInvitation: 'Add person',
          duplicateEmail: 'Duplicate email',
          internalServerError: 'Failed to invite'
        },
        membershipType: {
          individual: 'Individual',
          operator: 'Operator'
        },
        successfulMessage: 'Invited successfully',
        title: 'Invite Individually',
        whoToInvite: 'Who to invite',
        whoToInvitePlaceholder: 'Type name'
      },
      invitePeopleDialog: {
        addNewWorker: 'Add new worker',
        addPersonDialogDescription: 'A new member will be created and added to the invitation candidate list.',
        addPersonDialogTitle: 'Add member',
        addPersonInfoMessage: 'The member will be created and pre-selected as an invitation candidate.',
        batchProgress: 'Sending... ({{completed}}/{{total}})',
        cancel: 'Cancel',
        conditionPrerequisite: 'Prerequisite: No Staff Account or Inviting',
        conditionPrerequisiteIndividual: 'Prerequisite: No Individual Account or Inviting',
        conditions: 'Conditions',
        confirmDialog: {
          cancel: 'Cancel',
          close: 'Close',
          confirm: 'Invite',
          description: 'Send invitation emails to {{count}} people',
          inviteEmailOptions: {
            inviteBlocked: 'Invitation unavailable',
            inviteBlockedNoEmail: 'No email address registered. Please register an email address first.',
            kindBadgeBoth: 'Work/Personal',
            kindBadgePersonal: 'Personal',
            kindBadgeWork: 'Work'
          },
          note1: 'Invitation emails will be sent',
          note2: 'Links in the email expire after 2 weeks',
          note3: 'It may take some time for the status to be reflected',
          resultAllFailedMessage: 'Failed to send invitation emails. Invitations have been created. You can resend them using the "Resend" button on the list screen.',
          resultAllFailedTitle: 'Invitation Mail Error',
          resultFailedMailCount: '{{count}} failed (mail error)',
          resultFailedMailDetail: 'Mail failures ({{count}})',
          resultFailedMailNote: 'Invitations have been created for the affected users. You can resend them using the "Resend" button on the list screen.',
          resultInviteFailedCount: '{{count}} could not be invited',
          resultInviteFailedDetail: 'Invitation failures ({{count}})',
          resultInviteFailedMessage: 'The invitation could not be created. Resending will not resolve this — please fix the cause and try again.',
          resultInviteFailedNote: 'No invitation was created for the affected users. Resending will not help. Resolve the cause (e.g. a duplicate email address) and try again.',
          resultInviteFailedTitle: 'Invitation Failed',
          resultNewInviteCount: '{{count}} new invitation(s) completed',
          resultPartialErrorTitle: 'Invitation Result',
          resultProcessedFallback: 'Processing completed',
          resultReinvitedCount: '{{count}} reinvited (new invitation sent)',
          resultReinvitedDetail: 'Reinvited ({{count}})',
          resultReinvitedNote: 'These users were already invited. A new invitation email has been sent and the previous invitation link has been invalidated.',
          resultReinvitedSuccess: '{{count}} reinvitation(s) completed. New invitation email(s) have been sent.',
          resultReinvitedTitle: 'Reinvitation Complete',
          resultSkippedCount: '{{count}} skipped (already granted)',
          resultSkippedDetail: 'Skipped ({{count}})',
          resultSuccess: '{{count}} invitation(s) sent successfully',
          resultSuccessCount: '{{count}} succeeded',
          resultSuccessTitle: 'Invitation Complete',
          retryFailed: 'Retry failed',
          sending: 'Sending...',
          title: 'Confirm Invitation'
        },
        errorMessage: 'Failed to send invitation',
        hasIndividualAccount: 'Has individual account',
        hasOperatorAccount: 'Has operator account',
        individualTitle: 'Individual Account – Invite People',
        invite: 'Invite',
        joiningDate: 'Joining date',
        newHire: 'New hire',
        operatorTitle: 'Staff Account – Invite People',
        personalEmail: 'Personal',
        primaryEmail: 'Primary',
        searchPlaceholder: 'Search by name or e-mail...',
        selectedCount: '{{count}} selected',
        successMessage: 'Invitation sent successfully',
        targetEmailColumn: 'Target email'
      },
      tabs: {
        all: 'All',
        inviting: 'Inviting'
      }
    }
  },
  individual: {
    pageTitle: 'User Accounts & Auth / Individual'
  },
  operator: {
    pageTitle: 'User Accounts & Auth / Operator'
  },
  // operator(staff) / individual 共通
  settings: {
    description: 'Configure login requirements for each account type.',
    title: 'Login requirements'
  },
  title: 'User Accounts & Auth'
};
export default pagesSettingsPersonsEn;